export default {
    name: 'outputspending',
    component: () => import(/* webpackChunkName: "outputs-pending-layout" */ '@/modules/outputs/pending/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.outputs.pending.index',
            component: () => import(/* webpackChunkName: "outputs-pending-index" */ '@/modules/outputs/pending/views/Index'),
        },
        {
            path: 'create',
            name: 'dashboard.outputs.pending.create',
            component: () => import(/* webpackChunkName: "outputs-pending-create" */ '@/modules/outputs/pending/views/Create'),
        },
        {
            path: 'create/:id',
            name: 'dashboard.outputs.pending.create.outputdetails',
            component: () => import(/* webpackChunkName: "outputs-pending-create-outputdetails" */ '@/modules/outputs/pending/views/CreateOutputdetail'),
        },
        {
            path: ':id/edit',
            name: 'dashboard.outputs.pending.edit',
            component: () => import(/* webpackChunkName: "outputs-pending-edit" */ '@/modules/outputs/pending/views/Edit'),
        },
        {
            path: ':id/print',
            name: 'dashboard.outputs.pending.print',
            component: () => import(/* webpackChunkName: "outputs-pending-edit" */ '@/modules/outputs/pending/views/Print'),
        },
    ]
}